// Runtime backend URL — always matches the current domain.
// Avoids stale build-time REACT_APP_BACKEND_URL in production builds.
export const BACKEND_URL = window.location.origin;
